export default __webpack_public_path__ + "17f316c978e8373b4fdda943be7434fa.mp3";